import * as moment from 'moment-timezone';
import { MarketType } from 'src/solace';

export interface ITickerNews {
  instrumentType: MarketType;
  issueID: string;
  ticker: string;
  variation?: number;
}

export interface INewsResponse {
  id: number;
  category: number;
  date: string;
  header: string;
  priority: string;
  source: string;
  time: string;
  tags: string[];
  image_header: string;
  type: number;
}

export interface INews {
  id: number;
  category: number;
  date: string;
  header: string;
  priority: string;
  source: string;
  time: string;
  tags: string[];
  imageHeader: string;
  type: number;
}

export enum NEWS_CATEGORY {
  generals = 0,
  stockExchange = 604,
  business = 615,
  debt = 600,
  foreingExchange = 608,
  goods = 620,
  present = 618,
  economy = 617,
  latam = 619,
}

export enum NEWS_PRIORITY {
  fearuredNews = '1',
  newsAdvances = '0',
  automaticallyNews = '2',
}

export enum NEWS_TYPE {
  normal = 1,
  fixedService = 2,
  otherFixedService = 3,
  newsAdvances = 4,
}

export const NEWS_CATEGORY_LIST = [
  {
    id: 0,
    name: 'Generales',
  },
  {
    id: 604,
    name: 'Bolsa',
  },
  {
    id: 615,
    name: 'Empresas',
  },
  {
    id: 600,
    name: 'Deuda',
  },
  {
    id: 608,
    name: 'Divisas',
  },
  {
    id: 620,
    name: 'Actualidad',
  },
  {
    id: 618,
    name: 'Economía',
  },
];

export class NewsViewModel implements INews {
  static fromJSON(
    json: INewsResponse,
    searchServicesItems: any,
  ): NewsViewModel {
    const backupHeader = this.getImageHeaderFromId(json.id);
    return new NewsViewModel(
      json.id,
      json.category,
      json.date,
      json.header,
      json.priority,
      json.source,
      json.time,
      json.tags,
      json.image_header ? `https://${json.image_header}` : backupHeader,
      backupHeader,
      this.getSinceDate(json.time, json.date),
      json.type,
      this.getTickers(json.tags, searchServicesItems),
    );
  }

  static getImageHeaderFromId(id: number): string {
    // id % 10 will return a number between 0 and 9,
    // and our images are numbered from 1 to 10, so we add 1
    // to get a placeholder between 1 and 10.
    const placeholder = 1 + (id % 10);
    return `images/news/placeholder-${placeholder}-small.jpg`;
  }

  static getSinceDate(time: string, date: string): string {
    const startDate = date.substring(0, 10);
    return (
      moment
        // FIXME: The timezone should be specified in the date string from the
        // backend. This should be a temporary patch.
        .tz(startDate + ' ' + time, 'America/Mexico_City')
        .startOf('hour')
        .fromNow()
    );
  }

  static getTickers(tags: string[], searchServicesItems: any): ITickerNews[] {
    const tickerList: ITickerNews[] = [];

    tags.forEach((item) => {
      const foundTicker = searchServicesItems.find(
        (issue) => issue.ticker === item.toUpperCase(),
      );

      if (foundTicker) {
        const ticker: ITickerNews = {
          instrumentType: foundTicker.instrumentType,
          issueID: foundTicker.issueID,
          ticker: foundTicker.ticker,
        };
        tickerList.push(ticker);
      }
    });
    return tickerList;
  }

  constructor(
    public id: number,
    public category: number,
    public date: string,
    public header: string,
    public priority: string,
    public source: string,
    public time: string,
    public tags: string[],
    public imageHeader: string,
    public backupImageHeader: string,
    public since: string,
    public type: number,
    public issues?: ITickerNews[],
    public body?: string,
  ) {}
}
